<template>
    <div>
        <base-header class="mt-4 pb-6" type=""></base-header>
        <b-container fluid class="mt--6 container-padding">
            <div>
                <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
                <b-row>
                    <b-col cols="12">
                        <div class="card-wrapper">
                            <b-card>
                                <div slot="header">
                                    <b-row>
                                        <b-col md="8">
                                            <h3>{{title}}</h3>
                                        </b-col>
                                        <b-col md="2">
                                            <i class="fa fa-exclamation-triangle float-right text-red fa-3x" v-if="voucher.is_void == '1'" ></i>
                                        </b-col>
                                        <b-col md="2" v-if="voucher.id != null && !is_editing">
                                            <base-button type="secondary" @click="cancelVoucher" class="ml-2 float-right">
                                                <i class="fa fa-step-backward"></i>
                                            </base-button>
                                            <base-button type="success" @click="onClickNew" class="ml-2 float-right">
                                                <i class="fa fa-plus"></i>
                                            </base-button>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row>
                                    <b-col lg="2" :disabled="!is_editing">
                                        <base-input :label="language_terms['VOUCHER_DATE']">
                                        <!-- <input type="text" v-model="voucher.date" ref="datePicker" /> -->
                                        <flat-picker
                                            :config="datePickerConfig"
                                            v-model="voucher.date"
                                            @on-change="onChangeDate"
                                            :disabled="!is_editing"
                                            slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" style="background-color:white" class="form-control datepicker"
                                        />
                                        </base-input>
                                    </b-col>
                                    <!-- <b-col lg="2" :disabled="!is_editing">
                                        <base-input :label="language_terms['DOC_DATE']" >
                                            <flat-picker
                                                v-model="voucher.doc_date"
                                                :disabled="!is_editing"
                                                slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" style="background-color: white" class="form-control datepicker"
                                            />
                                        </base-input>
                                    </b-col> -->
                                    <b-col lg="4">
                                        <base-input :label="language_terms['DOCUMENT']" v-model="voucher.doc_reference" :disabled="!is_editing"></base-input>
                                    </b-col>
                                    <b-col lg="2" v-if="0">
                                        <base-input :label="language_terms['AMOUNT']" v-model="voucher.document_amount" type="NUMBER" :disabled="!is_editing"></base-input>
                                    </b-col>
                                    <b-col lg="2">
                                        <base-input :label="language_terms['CURRENCY']" :disabled="!is_editing">
                                            <el-select v-model="voucher.currency_code" filterable @change="onChangeCurrency" :disabled="!is_editing">
                                                <el-option v-for="option in currency_options"
                                                    :key="option.code"
                                                    :label="option.code + ' - ' + option.name"
                                                    :value="option.code">
                                                </el-option>
                                            </el-select>
                                        </base-input>
                                    </b-col>
                                    <b-col lg="2">
                                        <base-input :label="language_terms['EX_RATE']" :value="(voucher.currency_exchange_rate * 1).toLocaleString('en-US', {minimumFractionDigits:4, maximumFractionDigits:4})" :disabled = true></base-input>
                                    </b-col>
                                    <b-col lg="2" :disabled="!is_editing">
                                        <base-input label="Created Date" >
                                            <flat-picker
                                                :config="datePickerConfig"
                                                v-model="voucher.time_created"
                                                :disabled=true
                                                slot-scope="{ focus, blur }" @on-open="focus" @on-close="blur" class="form-control datepicker"
                                            />
                                        </base-input>
                                    </b-col>

                                    <!-- <b-col lg="2">
                                        <base-input :label="language_terms['REFERENCE']" v-model="voucher.reference" :disabled="!is_editing"></base-input>
                                    </b-col> -->
                                    <b-col lg="12">
                                        <base-input :label="language_terms['REMARKS']">
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="voucher.remarks" :disabled="!is_editing"></textarea>
                                        </base-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <b-card v-if="voucher.date != null && voucher.currency_code != null && (is_editing || (!is_editing && voucher.id != null))">
                                <div slot="header">
                                    <b-row>
                                        <b-col cols="10">
                                            <h3>{{language_terms['JOURNAL_ITEMS']}}</h3>
                                        </b-col>
                                    </b-row>
                                </div>
                                <b-row v-if="is_editing">
                                    <b-col md="1">
                                        <base-input :label="language_terms['DIRECTION']">
                                            <el-select
                                                v-model="item.direction" filterable :disabled="!is_editing">
                                                <el-option
                                                    v-for="option in direction_options"
                                                    :key="option.code"
                                                    :label="language_terms[option.name]"
                                                    :value="option.code">
                                                </el-option>
                                            </el-select>
                                        </base-input>  
                                    </b-col>                                    
                                    <b-col :md="item.account_item.is_taggable == '1'? 5 : 7">
                                        <label class="form-control-label">{{language_terms['ACCOUNT']}}</label>
                                        <multiselect
                                            v-model="item.account_item"
                                            @input="onSelectAccount"
                                            :disabled="!is_editing"
                                            :options="account_list"
                                            track-by="code"
                                            :multiple="false" :close-on-select="true" :clear-on-select="false" label="name" text-field="display_name"
                                            :searchable="true"
                                            :searchableText="'prefix'"
                                        />

                                    </b-col>
                                    <b-col md="4" v-if="item.account_item.is_taggable == '1'">
                                        <label class="form-control-label">{{language_terms['ACCOUNT_TAG']}}</label>
                                        <multiselect
                                            v-model="item.account_item_tag"
                                            :disabled="!is_editing"
                                            :options="item.account_item.tags"
                                            :multiple="false" 
                                            :taggable="true"
                                            @tag="addAccountItemTag($event)"                                            
                                            />
                                    </b-col>
                                    <b-col md="2">
                                        <base-input :label="language_terms['AMOUNT']" v-model="item.amount" type="NUMBER" :disabled="!is_editing"></base-input>
                                    </b-col>
                                    <b-col md="11">
                                        <base-input :label="language_terms['REMARKS']" v-model="item.remarks" :disabled="!is_editing"></base-input>
                                    </b-col>
                                    <b-col md="1" class="mt-4">
                                        <b-button v-if="item_index == null" variant="primary" @click="updateItem()" :disabled="!is_editing" class="mt-2">
                                            {{language_terms['ADD']}}
                                        </b-button>
                                        <b-button v-if="item_index != null"  variant="success" @click="updateItem()" :disabled="!is_editing" class="mt-2 fa fa-check"/>
                                        <!-- <base-button size="sm" icon type="danger" @click="deleteItem(index)"><i class="fas fa-trash-alt"></i ></base-button> -->
                                        <b-button v-if="item_index != null"  variant="danger" @click="onClickAbortItemUpdate()" :disabled="!is_editing" class="mt-2 fa fa-times"/>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" v-if="voucher.items.length > 0">
                                        <b-table-simple hover responsive>
                                            <b-thead head-variant="light">
                                                <b-th>{{language_terms['ACCOUNT_CODE']}}</b-th>
                                                <b-th>{{language_terms['ACCOUNT_NAME']}}</b-th>
                                                <b-th>{{language_terms['REMARKS']}}</b-th>
                                                <b-th>{{language_terms['DEBIT']}}</b-th>
                                                <b-th>{{language_terms['CREDIT']}}</b-th>
                                                
                                                <b-th></b-th>
                                            </b-thead>
                                            <b-tbody>
                                                <tr v-for="(item, index) in voucher.items" :key="index">
                                                    <td @click="onClickItem(index)">{{item.account_item_code}}</td>
                                                    <td @click="onClickItem(index)">{{item.account_item_name}}{{item.account_item_tag != null ? ' (' + item.account_item_tag + ')' : ''}}</td>
                                                    <td @click="onClickItem(index)">{{item.remarks}}</td>
                                                    <td @click="onClickItem(index)">{{(item.db_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                                    <td @click="onClickItem(index)">{{(item.cr_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})}}</td>
                                                    <td v-if="is_editing">
                                                        <base-button size="sm" icon type="danger" @click="deleteItem(index)"><i class="fas fa-trash-alt"></i ></base-button>
                                                    </td>
                                                </tr>
                                            </b-tbody>
                                        </b-table-simple>
                                    </b-col>
                                </b-row>
                                <b-row v-if="voucher.items.length > 0">
                                    <b-col md="4">
                                        <base-input label="Unbalanced Amount" :value="((voucher.total_db_amount * 1) - (voucher.total_cr_amount * 1)).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                    </b-col>
                                    <b-col md="4">
                                        <base-input :label="language_terms['TOTAL_DEBIT_AMOUNT']" :value="(voucher.total_db_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                    </b-col>
                                    <b-col md="4">
                                        <base-input :label="language_terms['TOTAL_CREDIT_AMOUNT']" :value="(voucher.total_cr_amount * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})" disabled></base-input>
                                    </b-col>
                                </b-row>                                
                            </b-card>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <!-- <b-button class="transparent-btn" @click="save" v-if="is_editing && (parseFloat(voucher.total_cr_amount.toFixed(2)) ==  parseFloat(voucher.total_db_amount.toFixed(2))) && voucher.items.length > 0"> -->
                        <b-button class="transparent-btn" @click="save">
                            <i class="fas fa-save mr-2 text-success"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancelVoucher" v-if="is_editing">
                            <i class="fas fa-times mr-2 text-danger"></i>{{language_terms['CANCEL']}}
                        </b-button>

                        <b-button class="transparent-btn" @click="onClickPrint" v-if="!is_editing">
                            <i class="fas fa-print mr-2 text-info"></i>{{language_terms['PRINT']}}
                        </b-button>

                        <b-button class="transparent-btn" v-if="voucher.id != null && !is_editing" @click="onClickEdit()">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>

                        <b-button class="transparent-btn" v-if="voucher.id != null && !is_editing && voucher.is_void == 0"  @click="onClickVoid()">
                            <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['VOID']}}
                        </b-button>

                        
                    </b-button-group>
                </div>
            </div>
        </b-container>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Vue from 'vue'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Select, Option } from "element-ui";
import moment from "moment";
import axios from "axios";
import { apiRoutes } from "../../../apiRoutes";
import { authHeader } from "../../../global";
import { format } from 'date-fns';

export default {
 components:{
    Loading,
    flatPicker,
    [Select.name]: Select,
    [Option.name]: Option
  },
  computed:{
        ...mapState({
            language_terms:(state)=>state.languages.language_terms,
            voucher_filter:(state)=>state.vouchers.gl_voucher_filter,
            account_data: state => state.accounts.data,
            is_created: state => state.vouchers.is_created,
            is_voided: state => state.vouchers.is_voided,
            voucher_data: state => state.vouchers.data,
            fys: (state) => state.accounts.fys,
            accounts_for_fy: (state) => state.accounts.accounts_for_fy,
            fy_by_date: (state) => state.accounts.fy_by_date
        })
    },
    data(){
       return{
            itemPettyCash: {
                code: "151130",
                is_taggable: "0",
                name: "PETTY CASH",
                tags: []
            },
            itemCashAtBank: {
                code: "151100",
                is_taggable: "1",
                name: "CASH AT BANK",
                tags: ["BPTR", "DBS", "OCBC-SGD", "OCBC-USD", "PC1", "UOB", "UOB - E", "UOB- U"]
            },
            datePickerConfig: {
                dateFormat: 'd/m/Y', // Display format
                // altInput: true, // Use an alternate input field
                // altFormat: 'Y-m-d', // Format for the alternate input field (yyyy-mm-dd)
            },
            item_index:null,
            is_editing:0,
            customers:[],
            loadingCounter:0,
            allowVoid:false,
            title:"",
            valid_fys:[],
            account_list:[],
            direction_options:[
                {code: "DB", name:"DEBIT"},
                {code: "CR", name:"CREDIT"}
            ],
            voucher:{
                id:null,
                code:"",
                date:new Date(),
                fy:null,
                type:null,
                account_id:null,
                reference:null,
                remarks:null,
                document:null,
                doc_date:new Date(),
                doc_reference:null,
                currency_code:'SGD',
                currency_exchange_rate:1,
                items:[],
                total_db_amount:0,
                total_cr_amount:0,
                is_void:null,
            },
            item:{
                account_item_tag:null,
                account_item:{is_taggable:0},
                account_item_code:null,
                account_item_name:null,
                debtor_contact_id:null,
                creditor_contact_id:null,
                amount:null,
                db_amount:null,
                cr_amount:null,
                direction:null,
                remarks:'',
            },
            currency_options:[],
            voucher_details:[],
            voucherModeOptions: [
                {
                value: "1",
                label: "1 Debit Many Credits",
                },
                {
                value: "2",
                label: "1 Credit Many Debits",
                },
                {
                value: "3",
                label: "Many Credits Many Debits",
                },
            ],
        }
   },
   async mounted()
   {
        let id = this.$route.params.id
        this.loadCurrencies()

        if(id == '_new')
        {
            this.title = this.language_terms['NEW_JOURNAL_VOUCHER']
            // this.voucher.date = moment().format("YYYY-MM-DD")
            this.voucher.date = moment().format("DD/MM/YYYY")

            await this.$store.dispatch("accounts/fetchFYs", {})

            if(this.fys)
            {
                this.valid_fys = this.fys.filter(function(item)
                {
                    return (item.fy != null);
                });

                // this.voucher.fy = this.valid_fys[0].fy
                this.getAllAccountsForFY()

                if (localStorage.getItem('jv_is_petty_cash') == 1)
                {
                    this.item.direction = 'CR'
                    this.item.account_item = this.itemPettyCash    
                }
                else if (localStorage.getItem('jv_is_bankaccount') == 1)
                {
                    this.item.direction = 'CR'
                    this.item.account_item = this.itemCashAtBank
                    //this.item.account_item.tags = []
                    // this.accounts_for_fy.forEach((c, index) => {
                    //     if (c.code == this.itemCashAtBank.code)
                    //     {
                    //         alert('x')
                    //         console.log(c.tags)
                    //         this.itemCashAtBank.tags = c.tags
                    //     }
                    // })                      
                    this.item.account_item_tag = localStorage.getItem('jv_bankaccount_tag')
                }
            }
            this.is_editing = true
        }
        else
        {
            await this.retrieveVoucher(id)
            
            this.title = this.language_terms['JOURNAL_VOUCHER'] + ' ' + [id]
            this.is_editing = false
            // this.voucher = this.voucher_data
            // this.title = this.voucher.voucher_code
            // if(this.voucher.allow_void)
            // {
            //     this.allowVoid = true
            // }
        }
   },
   methods:{
    convertDateToYMD(dmyDate) {
      // Split the inputDate into day, month, and year components
      const dateParts = dmyDate.split('/');
      let convertedDate = ''

      if (dateParts.length === 3) {
        const day = dateParts[0];
        const month = dateParts[1];
        const year = dateParts[2];

        // Create a new Date object in the desired format
        const formattedDate = new Date(`${year}-${month}-${day}`);
        
        // Extract the formatted date as a string in "yyyy-mm-dd" format
        convertedDate = formattedDate.toISOString().split('T')[0];
      } else {
        // Handle invalid input date format here
        convertedDate = ''; // You can display an error message or clear the field
      }

      return convertedDate
    },    
    convertDateToDMY(ymdDate) {
      // Split the inputDate into year, month, and day components
      const dateParts = ymdDate.split('-');
      let convertedDate = ''

      if (dateParts.length === 3) {
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];

        // Create a new Date object in the desired format
        const formattedDate = new Date(`${year}-${month}-${day}`);
        
        // Extract the formatted date as a string in "dd/mm/yyyy" format
        const formattedDay = String(formattedDate.getDate()).padStart(2, '0');
        const formattedMonth = String(formattedDate.getMonth() + 1).padStart(2, '0');
        const formattedYear = formattedDate.getFullYear();
        convertedDate = `${formattedDay}/${formattedMonth}/${formattedYear}`;
      }
    
      return convertedDate
    },    
    onClickPrint()
    {
        this.loadingCounter++
        let url = 'https://reports.unityerp.com/esteam/journal-voucher/' + encodeURIComponent(localStorage.access_token)
        + '/' + encodeURIComponent(this.voucher.code)
        window.open(url , '_blank');
       
        this.loadingCounter--
    },
    onClickNew() 
    {
        window.location.href = '/finance/journal-voucher/_new'
    },
    onClickAbortItemUpdate()
    {
        this.item_index = null
    },
    onClickItem(index)
    {
        this.item = JSON.parse(JSON.stringify(this.voucher.items[index]))
        this.item_index = index
    },
    async onSelectAccount(selectedOption)
    {
        this.item.account_item_tag = null
    },
    async addAccountItemTag(newTag, index)
    {
      if (newTag)
      {
        // let obj = {id: null, code: null, name:newTag}
        if(this.isFoundInTagList(newTag) == 0)
        {
            this.item.account_item.tags.push(newTag)
        }
        this.item.account_item_tag = newTag
      }
    },
    isFoundInTagList(name)
    {
        let is_found = 0
        for(let i = 0; i < this.item.account_item; i++)
        {
            if(this.item.account_item[i].name == name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    async onClickEdit()
    {
    // alert('x')
        this.voucher.total_cr_amount = 0
        this.voucher.total_db_amount = 0
        
        this.is_editing = true
    },
    async onClickVoid()
    {
        let response =  await this.$confirm('Proceed to void?', this.language_terms['CONFIRMATION'], {
        confirmButtonText: this.language_terms['YES'],
        cancelButtonText: this.language_terms['CANCEL'],
        type: 'warning'
        }).catch(() => {
          //this.$message.info(this.language_terms['ACTION_CANCEL'])
        })

        if (response === 'confirm') {
            let voucher_id = this.voucher.id
            let payload = { id: voucher_id};
            axios.post(apiRoutes["JOURNALVOUCHERS_VOID"], payload, authHeader()).then((response) => {
                if (response.data.code == 1) 
                {
                    location.reload();
                } 
                else 
                {
                    Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
                }
            })
            .catch((error) => 
            {
                if (error.response) 
                {
                    Vue.notify({group: "notify",type: "error",text: error.response.data.msg,max: 5,duration: 5000,speed: 300,});
                } 
            });
        }
    },
    async retrieveVoucher(code)
    {
        this.loadingCounter++
        let payload = {code:code}
            await axios
            .post(apiRoutes["ACCOUNTS_RETRIEVE_VOUCHER"], payload, authHeader())
            .then((response) => 
            {
                if (response.data.code == 1) {
                    this.voucher = response.data.data
                    this.voucher.date = this.convertDateToDMY(this.voucher.date)
                    this.voucher.time_created = this.convertDateToDMY(this.voucher.time_created)
                    this.getAllAccountsForFY()
                } 
                else 
                {
                    alert('Failed');
                }
            })
            .catch((error) => {
                if (error.response) {
                    Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
                }
            });
        this.loadingCounter--
    },

    async onChangeCurrency(option)
    {
        this.voucher.currency_exchange_rate = null

        this.currency_options.forEach((c, index) => {
            if (c.code == option)
                this.voucher.currency_exchange_rate = c.rate
        })        
    },
    limitText(count)
    {
        return `and ${count} other customers`;
    },
    async loadCurrencies()
    {
        let payload = []
        await axios
        .post(apiRoutes["CURRENCIES_LIST"], payload, authHeader())
        .then((response) => 
        {
            if (response.data.code == 1) {
                this.currency_options = response.data.data
            } 
            else 
            {
                Vue.notify({group: "notify", type: "error", text: 'Failed', max: 5, duration: 5000, speed: 300,});
            }

        })
        .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
    },
    async onChangeDate()
    {   
        //console.log(this.voucher.voucher_date)
        await this.$store.dispatch("accounts/getFyByDate", {date:this.voucher.voucher_date})

        //console.log(this.fy_by_date)

        if(this.fy_by_date)
        {
            this.voucher.fy = this.fy_by_date.fy
            this.getAllAccountsForFY()

        }
    },
    async searchVouchers()
    {
        this.loadingCounter++
        let filter = {
            keyword:"",
                active_only:"1",
                type:"GL"
        }
        if(this.voucher_filter)
        {
            filter = this.voucher_filter
        }
        await this.$store.dispatch('vouchers/quickSearch', filter)

        this.loadingCounter--
    },
    cancelVoucher()
    {
        this.$router.push("/finance/journal-vouchers")
    },
    async voidVoucher()
    {
    await this.$store.dispatch("vouchers/voidVoucher", {id:this.voucher.id})

        if(this.is_voided == 1)
        {
            await this.searchVouchers()
            this.$router.push("/finance/gl-vouchers")
        }
    },
    deleteItem(index)
    {
        this.voucher.items.splice(index, 1);
        this.recomputeSummary();
    },
    updateItem()
    {
        let amount = this.item.amount

        if(this.item.direction == 'DB')
        {
            this.item.db_amount = amount
            this.item.cr_amount = null
        }
        else if(this.item.direction == 'CR')
        {
            this.item.db_amount = null
            this.item.cr_amount = amount
        }

        if (this.item.direction == null || this.item.direction == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Direction has to be selected', max: 5, duration: 5000, speed: 300})
        }
        else if (this.item.account_item == null)
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Account has to be selected', max: 5, duration: 5000, speed: 300})
        }
        else if (this.item.account_item.is_taggable == "1" && this.item.account_item_tag == null)
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Account tag has to be specified', max: 5, duration: 5000, speed: 300})
        }
        else if (amount == null || amount == '')
        {
            Vue.notify({group: 'notify', type: 'error', text: 'Amount has to be entered', max: 5, duration: 5000, speed: 300})
        }
        else
        {
            this.item.account_item_code = this.item.account_item.code
            this.item.account_item_name = this.item.account_item.name

            // let item = {
            //     account_item_code:this.item.account_item_code,
            //     account_item_name:this.item.account_item_name,
            //     debtor_contact_id:this.item.debtor_contact_id,
            //     creditor_contact_id:this.item.creditor_contact_id,
            //     amount:this.item.amount,
            //     db_amount:this.item.db_amount,
            //     cr_amount:this.item.cr_amount,
            //     direction:this.item.direction,            
            //     account_item_tag:this.item.account_item_tag,
            //     remarks:this.item.remarks,
            //     is_taggable:this.item.account_item.is_taggable,
            // }

            if (this.item_index == null)
                this.voucher.items.push(JSON.parse(JSON.stringify(this.item)))
            else
                this.voucher.items[this.item_index] = JSON.parse(JSON.stringify(this.item))

            // alert(JSON.stringify(this.item))
            // console.log(JSON.stringify(this.item))

            this.item_index = null
            this.item.amount = null

            this.recomputeSummary()
        }
    },
    recomputeSummary()
    {
        this.voucher.total_db_amount = 0
        this.voucher.total_cr_amount = 0
        localStorage.setItem('jv_is_petty_cash', 0)
        localStorage.setItem('jv_is_bankaccount', 0)
        localStorage.setItem('jv_bankaccount_tag', '')

        this.voucher.items.forEach((i, index) => {
            if (index == 0)
            {
                // console.log(i)
                if (index == 0 && i.account_item_code == '151130' && i.direction == 'CR')
                {
                    localStorage.setItem('jv_is_petty_cash', 1)
                }
                else if (index == 0 && i.account_item_code == '151100' && i.direction == 'CR')
                {
                    localStorage.setItem('jv_is_bankaccount', 1)
                    localStorage.setItem('jv_bankaccount_tag', i.account_item_tag)
                }
            }
                

            if (i.direction == 'DB')
                this.voucher.total_db_amount += (i.amount * 1)
            else if (i.direction == 'CR')
                this.voucher.total_cr_amount += (i.amount * 1)

        })
        // alert (this.voucher.total_db_amount + ' ' + this.voucher.total_cr_amount)
        
    },
    onChangeFinancialYear()
    {
        this.getAllAccountsForFY()
    },
    async getAllAccountsForFY()
    {
        this.loadingCounter++
        // let filter = {fy:this.voucher.fy}
        let filter = {date:this.voucher.date}
        await this.$store.dispatch("accounts/getAccountForFys", filter)
        this.account_list = this.accounts_for_fy
        // console.log(this.account_list)
        this.loadingCounter--
    },
    async save()
    {
        let payload = JSON.parse(JSON.stringify(this.voucher));
        payload.date = this.convertDateToYMD(payload.date)

        await axios.post(apiRoutes["ACCOUNTS_SAVE_VOUCHER"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) {
                let doc_number  = response.data.data.code
                Vue.notify({text: 'Voucher (' + doc_number + ')' + " has been created!", group: 'notify', type: 'success', max: 5, duration: 5000,speed: 300})
                // this.$router.push('/finance/journal-voucher/' + encodeURIComponent(doc_number))
                window.location.href = '/finance/journal-voucher/' + encodeURIComponent(doc_number)
                // this.$router.push("/finance/journal-vouchers")
            } else {
                let errors = response.data.data.errors
                
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({group: 'notify', type: 'error', text: msg, max: 5, duration: 5000, speed: 300})
                }
            }
            })
            .catch((error) => {
            if (error.response) {
                Vue.notify({group: 'notify', type: 'error', text: error.response.data.message, max: 5, duration: 5000, speed: 300})
            }
        });
    }
    }
}
</script>
